/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function (){
  $("#section-template--16505907445996__166417546129b10dc1 .Button, #section-template--16505907445996__16641662809b2e57c3 .Button, #section-template--16505907445996__16641977840df961fa .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#section-template--16505907445996__16641728280acf7387').offset().top - 80
       }, 1000);               
  });

   $("#section-template--16772824629484__16641662809b2e57c3 .Button, #section-template--16772824629484__16641977840df961fa .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#shopify-section-template--16772824629484__16641728280acf7387').offset().top - 80
       }, 1000);               
  });

   $("#section-template--16779947868396__16641662809b2e57c3 .Button, #section-template--16779947868396__16641977840df961fa .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#shopify-section-template--16779947868396__16641728280acf7387').offset().top - 80
       }, 1000);               
  });

  
  
  $("#section-template--16529213489388__1664598339f24fab42 .Button, #section-template--16529213489388__1664539947f0d9dc4a .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#section-template--16529213489388__16645405943a339b02').offset().top - 80
       }, 1000);               
  });

   $("#section-template--16617840804076__616655a8-2f7d-4eaf-91af-62990491fac0 .Button, #shopify-section-template--16617840804076__efaa64c5-6393-45a8-8cd6-ac554a0933e4 .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#shopify-section-template--16617840804076__63b89025-dfdd-4288-b1fd-e05eb178e82a').offset().top - 80
       }, 1000);               
  });

  $("#section-template--16623219638508__06856d80-de69-43ba-a936-de47a79c4acb .Button, #section-template--16623219638508__2b4d11a9-ec70-4eee-b8ae-7fd530983a11 .Button2").on('click',function(e){ 
     e.preventDefault();
     var $target = $(this).attr('href');
       $('html, body').animate({
            scrollTop: $('#section-template--16623219638508__8c42e1ff-1242-4853-979f-93188ff57462').offset().top - 80
       }, 1000);               
  });

  

  /*-------------- interior popup --------------*/
  $('#section-template--16396379160812__1661862977e9eb547677 .Button, #section-template--16396379160812__16618665072148d65a77 .Button').on('click', function(e){
    e.preventDefault();
    $('#interiorModal').show();
  });
  $('.interior_close').on('click', function(){
    $('#interiorModal').hide();
  });
  var interiorModal = document.getElementById("interiorModal");
  window.onclick = function(event) {
    if (event.target == interiorModal) {
      interiorModal.style.display = "none";
    }
  }
  $('.dimension-heading').on('click', function(){
    $(this).parent().find('.dimension-content').slideToggle();
    $(this).toggleClass('open');
  });
  $('.additional_details-heading').on('click', function(){
    $(this).parent().find('.additional_details-content').slideToggle();
    $(this).toggleClass('open');
  });
  $('.description-heading').on('click', function(){
    $(this).parent().find('.description-content').slideToggle();
    $(this).toggleClass('open');
  });
  $('.delivery-estimates-heading').on('click', function(){
    $(this).parent().find('.delivery-estimates-content').slideToggle();
    $(this).toggleClass('open');
  });
});


$(document).ready(function() {
    // Open popup on button click
    $('#member-pricing-btn').click(function() {
        $('#popupmem').fadeIn();
        $('body').addClass('no-scrolln');
    });
 
    // Close popup on close button click or outside click
    $('.closemem-btn, .popup-overlaymem').click(function() {
        $('#popupmem').fadeOut();
            $('body').removeClass('no-scrolln');
    });
 
    // Prevent closing the popup when clicking inside content
    $('.popupmem-content').click(function(event) {
        event.stopPropagation();
    });
});

/**
 * Contact Support Button - Open Live Chat Widget
 * This function handles opening the live chat widget when the contact support button is clicked
 * Updated to handle Zendesk initialization properly and prevent race conditions
 */
(function() {
  let zendeskReady = false;
  let zendeskCheckAttempts = 0;
  const maxZendeskCheckAttempts = 100; // 10 seconds max wait time
  
  /**
   * Check if Zendesk is fully loaded and ready
   */
  function checkZendeskReady() {
    return new Promise((resolve) => {
      // If already ready, resolve immediately
      if (zendeskReady || (window.zE && typeof window.zE === 'function')) {
        zendeskReady = true;
        resolve(true);
        return;
      }
      
      // Check periodically for Zendesk to load (every 100ms, up to 10 seconds)
      const checkInterval = setInterval(() => {
        zendeskCheckAttempts++;
        
        if (window.zE && typeof window.zE === 'function') {
          zendeskReady = true;
          clearInterval(checkInterval);
          resolve(true);
        } else if (zendeskCheckAttempts >= maxZendeskCheckAttempts) {
          clearInterval(checkInterval);
          console.warn('Zendesk widget did not load within expected time');
          resolve(false);
        }
      }, 100);
    });
  }
  
  /**
   * Try to open Zendesk messenger
   */
  function openZendeskMessenger() {
    if (!window.zE || typeof window.zE !== 'function') {
      console.warn('Zendesk not available');
      return false;
    }
    
    try {
      // Modern Zendesk Web Widget (Messenger)
      window.zE('messenger', 'open');
      return true;
    } catch (e) {
      console.warn('Failed to open Zendesk messenger:', e);
      
      // Fallback: Try legacy Zendesk API
      try {
        if (window.zE.activate) {
          window.zE.activate();
          return true;
        }
      } catch (legacyError) {
        console.warn('Legacy Zendesk API also failed:', legacyError);
      }
    }
    
    return false;
  }
  
  /**
   * Try all available chat widget methods
   */
  function tryOpenChatWidget(e) {
    e.preventDefault();
    
    // Priority 1: Zendesk (since your site uses Zendesk)
    if (openZendeskMessenger()) {
      return;
    }
    
    // Priority 2: Try other common chat widgets as fallbacks
    // Intercom
    if (window.Intercom) {
      try {
        window.Intercom('show');
        return;
      } catch (e) {
        // Silent fail, try next method
      }
    }
    
    // Front Chat
    if (window.FrontChat) {
      try {
        window.FrontChat('show');
        return;
      } catch (e) {
        // Silent fail, try next method
      }
    }
    
    // Drift
    if (window.drift) {
      try {
        window.drift.api.openChat();
        return;
      } catch (e) {
        // Silent fail, try next method
      }
    }
    
    // HubSpot
    if (window.HubSpotConversations) {
      try {
        window.HubSpotConversations.widget.open();
        return;
      } catch (e) {
        // Silent fail, try next method
      }
    }
    
    // LiveChat
    if (window.LC_API) {
      try {
        window.LC_API.open_chat_window();
        return;
      } catch (e) {
        // Silent fail, try next method
      }
    }
    
    // Crisp
    if (window.$crisp) {
      try {
        window.$crisp.push(['do', 'chat:open']);
        return;
      } catch (e) {
        // Silent fail, try next method
      }
    }
    
    // Tawk.to
    if (window.Tawk_API) {
      try {
        window.Tawk_API.maximize();
        return;
      } catch (e) {
        // Silent fail, try next method
      }
    }
    
    // Fallback: Try to trigger click on Zendesk launcher iframe
    const launcherIframe = document.getElementById('launcher') || 
                          document.querySelector('iframe[id*="launcher"]') ||
                          document.querySelector('iframe[title*="Messaging"]');
    
    if (launcherIframe) {
      try {
        // Try clicking parent container (more reliable than iframe)
        if (launcherIframe.parentElement) {
          launcherIframe.parentElement.click();
          return;
        }
        
        // Try clicking the iframe itself
        const clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        });
        launcherIframe.dispatchEvent(clickEvent);
        return;
      } catch (e) {
        console.warn('Failed to click launcher iframe:', e);
      }
    }
    
    // Last resort: Try to find and click any Zendesk launcher button
    const launcherButtons = [
      'button[data-testid*="launcher"]',
      'button[aria-label*="chat"]',
      'button[aria-label*="help"]',
      'button[aria-label*="support"]',
      '[role="button"][id*="launcher"]',
      '.zEWidget-launcher'
    ];
    
    for (let selector of launcherButtons) {
      const button = document.querySelector(selector);
      if (button) {
        try {
          button.click();
          return;
        } catch (e) {
          // Continue to next selector
        }
      }
    }
    
    console.error('Could not open any chat widget. Zendesk may not be loaded yet.');
  }
  
  /**
   * Initialize the contact support button
   */
  function initContactSupportButton() {
    const contactSupportBtn = document.getElementById('contactSupportBtn');
    
    if (!contactSupportBtn) {
      console.warn('Contact support button not found');
      return;
    }
    
    // Add a loading state to the button until Zendesk is ready
    contactSupportBtn.style.cursor = 'wait';
    contactSupportBtn.style.opacity = '0.7';
    
    // Wait for Zendesk to be ready
    checkZendeskReady().then((ready) => {
      // Remove loading state
      contactSupportBtn.style.cursor = 'pointer';
      contactSupportBtn.style.opacity = '1';
      
      if (!ready) {
        console.warn('⚠️ Zendesk widget may not be fully loaded, but button will still try');
      }
      
      // Add click handler
      contactSupportBtn.addEventListener('click', tryOpenChatWidget);
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactSupportButton);
  } else {
    // DOM already loaded
    initContactSupportButton();
  }
  
  // Also listen for Zendesk-specific ready event
  window.addEventListener('load', () => {
    // Give Zendesk a bit more time after page load
    setTimeout(() => {
      if (window.zE && !zendeskReady) {
        zendeskReady = true;
      }
    }, 1000);
  });
})();

/**
 * Product Gallery Navigation Synchronization
 * Ensures thumbnails, dots, and arrow navigation stay in sync
 */
(function() {
  'use strict';
  
  // Wait for DOM to be ready
  function initProductGalleryNavigation() {
    var mainSlideshow = document.querySelector('.Product__Slideshow.Carousel');
    if (!mainSlideshow) {
      return;
    }
    
    var attempts = 0;
    var maxAttempts = 100;
    
    var initInterval = setInterval(function() {
      attempts++;
      
      // Try to get Flickity instance
      var flickityInstance = null;
      if (mainSlideshow.flickity) {
        flickityInstance = mainSlideshow.flickity;
      } else if (typeof Flickity !== 'undefined') {
        flickityInstance = Flickity.data(mainSlideshow);
      }
      
      if (flickityInstance || attempts >= maxAttempts) {
        clearInterval(initInterval);
        
        if (!flickityInstance) {
          console.warn('⚠️ Flickity instance not found after', attempts, 'attempts');
          return;
        }
        
        if (mainSlideshow.dataset.pfProductGalleryNav === '1') {
          return;
        }
        mainSlideshow.dataset.pfProductGalleryNav = '1';
        setupProductNavigation(flickityInstance);
      }
    }, 100);
  }
  
  function setupProductNavigation(flickity) {
    function resolveSelectedIndex(hint) {
      if (typeof hint === 'number' && isFinite(hint) && hint >= 0) {
        return hint;
      }
      var si = flickity.selectedIndex;
      if (typeof si === 'number' && isFinite(si) && si >= 0) {
        return si;
      }
      return 0;
    }
    
    // Get all navigation elements
    var thumbnails = document.querySelectorAll('.Product__SlideshowNav--thumbnails .Product__SlideshowNavImage');
    var desktopDots = document.querySelectorAll('.Product__SlideshowNav--dots .Product__SlideshowNavDot');
    var mobileDots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');
    
    // Function to sync all navigation elements
    function syncNavigation(selectedIndex) {
      var idx = resolveSelectedIndex(selectedIndex);
      
      // Sync thumbnails
      thumbnails.forEach(function(thumb, index) {
        if (index === idx) {
          thumb.classList.add('is-selected');
        } else {
          thumb.classList.remove('is-selected');
        }
      });
      
      // Sync desktop dots
      desktopDots.forEach(function(dot, index) {
        if (index === idx) {
          dot.classList.add('is-selected');
        } else {
          dot.classList.remove('is-selected');
        }
      });
      
      // Sync mobile dots
      mobileDots.forEach(function(dot, index) {
        if (index === idx) {
          dot.classList.add('is-selected');
        } else {
          dot.classList.remove('is-selected');
        }
      });
      
    }
    
    // Listen to Flickity change events (first argument is not always the cell index)
    flickity.on('change', function(index) {
      var i = resolveSelectedIndex(index);
      syncNavigation(i);
    });
    
    // Listen to Flickity settle event (when animation completes)
    flickity.on('settle', function(index) {
      var i = resolveSelectedIndex(typeof index === 'number' ? index : flickity.selectedIndex);
      syncNavigation(i);
    });
    
    // Listen to Flickity select event (immediate selection; signature is often (e, idx) or no index)
    flickity.on('select', function() {
      var i = resolveSelectedIndex(flickity.selectedIndex);
      syncNavigation(i);
    });
    
    // Arrow navigation is handled by theme.js — no duplicate handlers needed here
    
    // Thumbnail clicks
    thumbnails.forEach(function(thumb, index) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        flickity.select(index);
      });
    });
    
    // Desktop dot clicks
    desktopDots.forEach(function(dot, index) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        flickity.select(index);
      });
    });
    
    // Mobile dot clicks
    mobileDots.forEach(function(dot, index) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        flickity.select(index);
      });
    });
    
    // Initial sync
    syncNavigation(resolveSelectedIndex(flickity.selectedIndex));
    
    // Periodic sync check as failsafe (every 500ms)
    // This ensures thumbnails stay in sync even if events are missed
    var syncCheckInterval = setInterval(function() {
      var currentSelected = resolveSelectedIndex(flickity.selectedIndex);
      var thumbnailSelected = Array.from(thumbnails).findIndex(function(thumb) {
        return thumb.classList.contains('is-selected');
      });
      
      // If thumbnail doesn't match carousel, force sync
      if (thumbnailSelected !== currentSelected) {
        syncNavigation(currentSelected);
      }
    }, 500);
    
    // Clean up interval when navigating away (if needed)
    window.addEventListener('beforeunload', function() {
      clearInterval(syncCheckInterval);
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGalleryNavigation);
  } else {
    initProductGalleryNavigation();
  }

  window.addEventListener('load', function () {
    var el = document.querySelector('.Product__Slideshow.Carousel');
    if (!el || el.dataset.pfProductGalleryNav === '1') {
      return;
    }
    var inst = el.flickity || (typeof Flickity !== 'undefined' ? Flickity.data(el) : null);
    if (inst) {
      el.dataset.pfProductGalleryNav = '1';
      setupProductNavigation(inst);
    }
  });
})();

/**
 * Klaviyo reviews diagnostics — off by default.
 * Enable: add ?debug_klaviyo_reviews=1 to the URL, or
 *   localStorage.setItem('debug_klaviyo_reviews','1') or sessionStorage equivalent, then reload.
 */
(function () {
  function klaviyoReviewsDebugEnabled() {
    try {
      if (typeof window === 'undefined') return false;
      if (/\bdebug_klaviyo_reviews=1\b/.test(window.location.search || '')) return true;
      if (window.sessionStorage && window.sessionStorage.getItem('debug_klaviyo_reviews') === '1') {
        return true;
      }
      if (window.localStorage && window.localStorage.getItem('debug_klaviyo_reviews') === '1') {
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  }
  window.__klaviyoReviewsDebugLog = function () {
    if (!klaviyoReviewsDebugEnabled()) return;
    var parts = ['[Klaviyo reviews]'];
    for (var i = 0; i < arguments.length; i++) {
      parts.push(arguments[i]);
    }
    console.debug.apply(console, parts);
  };
  window.__klaviyoReviewsDebugIsEnabled = klaviyoReviewsDebugEnabled;
})();

/**
 * Deep layout snapshot for Klaviyo **product reviews list** (not only star widget).
 * Runs only when Klaviyo debug is on. Safari Private often breaks storage / third-party data — check storage probe + hidden ancestors.
 */
(function () {
  var dbg = window.__klaviyoReviewsDebugLog || function () {};

  function isDbg() {
    return typeof window.__klaviyoReviewsDebugIsEnabled === 'function' && window.__klaviyoReviewsDebugIsEnabled();
  }

  function storageProbe(run) {
    try {
      run();
      return 'ok';
    } catch (e) {
      return e && e.name ? e.name : String(e);
    }
  }

  var browserContextLogged = false;

  function logBrowserContextOnce() {
    if (!isDbg() || browserContextLogged) return;
    browserContextLogged = true;
    var ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    dbg('product-reviews:browser', {
      userAgent: ua,
      vendor: typeof navigator !== 'undefined' ? navigator.vendor : '',
      cookieEnabled: typeof navigator !== 'undefined' ? navigator.cookieEnabled : null,
      isSecureContext: typeof window.isSecureContext === 'boolean' ? window.isSecureContext : null,
      visibilityState: typeof document.visibilityState === 'string' ? document.visibilityState : null,
      localStorageProbe: storageProbe(function () {
        if (window.localStorage) {
          window.localStorage.setItem('__klaviyo_reviews_dbg', '1');
          window.localStorage.removeItem('__klaviyo_reviews_dbg');
        }
      }),
      sessionStorageProbe: storageProbe(function () {
        if (window.sessionStorage) {
          window.sessionStorage.setItem('__klaviyo_reviews_dbg', '1');
          window.sessionStorage.removeItem('__klaviyo_reviews_dbg');
        }
      }),
      likelySafari: /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|EdgiOS/i.test(ua)
    });
  }

  function elementLayoutProbe(el, label) {
    if (!el) {
      return { label: label, missing: true };
    }
    var cs = window.getComputedStyle(el);
    var r = el.getBoundingClientRect();
    return {
      label: label,
      tag: el.tagName,
      id: el.id || null,
      inlineDisplay: el.style.display || null,
      computed: {
        display: cs.display,
        visibility: cs.visibility,
        opacity: cs.opacity,
        contentVisibility: cs.contentVisibility || '',
        height: cs.height,
        maxHeight: cs.maxHeight,
        overflow: cs.overflow,
        overflowY: cs.overflowY
      },
      rect: {
        top: Math.round(r.top),
        left: Math.round(r.left),
        width: Math.round(r.width),
        height: Math.round(r.height)
      },
      inViewport:
        r.bottom > 0 &&
        r.right > 0 &&
        r.top < window.innerHeight &&
        r.left < window.innerWidth
    };
  }

  function ancestorVisibilityChain(el, maxDepth) {
    maxDepth = maxDepth || 15;
    if (!el) return [];
    var out = [];
    var cur = el;
    var depth = 0;
    while (cur && cur.nodeType === 1 && depth < maxDepth) {
      var cs = window.getComputedStyle(cur);
      var op = parseFloat(cs.opacity);
      var blocked =
        cs.display === 'none' || cs.visibility === 'hidden' || (isFinite(op) && op === 0);
      var cls = typeof cur.className === 'string' ? cur.className : '';
      out.push({
        depth: depth,
        tag: cur.tagName,
        id: cur.id ? cur.id.slice(0, 72) : '',
        classShort: cls.split(/\s+/).slice(0, 5).join('.'),
        display: cs.display,
        visibility: cs.visibility,
        opacity: cs.opacity,
        blocksVisibility: blocked
      });
      cur = cur.parentElement;
      depth++;
    }
    return out;
  }

  function snapshot(runSource) {
    if (!isDbg()) return;
    logBrowserContextOnce();

    var wrapper = document.getElementById('klaviyo-product-reviews-wrapper');
    var fulfilled = document.getElementById('fulfilled-reviews-all');
    var listRoot = document.querySelector('.kl_reviews__reviews_list');
    var reviewslist = document.getElementById('reviewslist');
    var blocks = document.querySelectorAll('.shopify-app-block[id*="klaviyo_reviews_product_reviews"]');

    dbg('product-reviews:snapshot', runSource, {
      wrapper: elementLayoutProbe(wrapper, '#klaviyo-product-reviews-wrapper'),
      fulfilled: elementLayoutProbe(fulfilled, '#fulfilled-reviews-all'),
      reviewsListSection: elementLayoutProbe(listRoot, '.kl_reviews__reviews_list'),
      reviewslist: elementLayoutProbe(reviewslist, '#reviewslist'),
      reviewItemCount: document.querySelectorAll('.kl_reviews__review_item').length,
      histogramRows: document.querySelectorAll('.kl_reviews__histogram__row').length,
      productReviewsAppBlockCount: blocks.length,
      productReviewsBlockIds: Array.prototype.map.call(blocks, function (n) {
        return n.id;
      })
    });

    if (wrapper) {
      dbg('product-reviews:ancestors-all', ancestorVisibilityChain(wrapper));
      var hiddenAncestors = ancestorVisibilityChain(wrapper).filter(function (row) {
        return row.blocksVisibility;
      });
      if (hiddenAncestors.length) {
        dbg('product-reviews:ancestors-hiding', hiddenAncestors);
      }
    } else {
      dbg(
        'product-reviews:wrapper-missing',
        'No #klaviyo-product-reviews-wrapper yet — Klaviyo JS may be blocked, template missing block, or still hydrating.'
      );
    }

    if (blocks.length) {
      var block0 = blocks[0];
      dbg('product-reviews:app-block[0]', elementLayoutProbe(block0, 'shopify-app-block'), {
        blockInlineDisplay: block0.style.display,
        hidingAncestors: ancestorVisibilityChain(block0).filter(function (r) {
          return r.blocksVisibility;
        })
      });
    }

    var starWidgets = document.querySelectorAll('.klaviyo-star-rating-widget');
    dbg('product-reviews:context', {
      starRatingWidgetCount: starWidgets.length,
      templateProduct: document.body && document.body.classList ? document.body.className.indexOf('template-product') !== -1 : null
    });
  }

  window.klaviyoReviewsDebugSnapshot = snapshot;

  function init() {
    if (!isDbg()) return;
    snapshot('init');
    setTimeout(function () {
      snapshot('timer-1000ms');
    }, 1000);
    setTimeout(function () {
      snapshot('timer-4000ms');
    }, 4000);
    setTimeout(function () {
      snapshot('timer-10000ms');
    }, 10000);
    setTimeout(function () {
      snapshot('timer-20000ms');
    }, 20000);

    var debounce = null;
    var mo = new MutationObserver(function () {
      if (!isDbg()) return;
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(function () {
        debounce = null;
        snapshot('mutation-400ms-debounce');
      }, 400);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Hide Klaviyo Reviews when product has 0 reviews — disabled (set flag true to re-enable).
 */
(function() {
  var ENABLE_HIDE_KLAVIYO_ZERO_REVIEWS = false;
  if (!ENABLE_HIDE_KLAVIYO_ZERO_REVIEWS) {
    return;
  }

  var dbg = window.__klaviyoReviewsDebugLog || function () {};

  function hideKlaviyoZeroReviews(runSource) {
    runSource = runSource || 'run';
    var klaviyoWidgets = document.querySelectorAll('.klaviyo-star-rating-widget');
    dbg('hide:check', runSource, {
      widgetCount: klaviyoWidgets.length,
      visibilityState: typeof document.visibilityState === 'string' ? document.visibilityState : undefined
    });

    klaviyoWidgets.forEach(function(widget, index) {
      var button = widget.querySelector('.kl_reviews__star_rating_widget');
      var ariaLabel = button ? button.getAttribute('aria-label') : null;
      var label = widget.querySelector('.kl_reviews__star_rating_widget__label');
      var labelText = label ? label.textContent.trim() : '';
      var parentBlock = widget.closest('.shopify-block.shopify-app-block');
      var summary = {
        index: index,
        ariaLabel: ariaLabel,
        labelText: labelText,
        hasButton: !!button,
        widgetDisplay: widget.style.display,
        parentId: parentBlock ? parentBlock.id : null,
        parentDisplay: parentBlock ? parentBlock.style.display : null
      };

      var hid = false;
      if (button) {
        if (ariaLabel && (ariaLabel.indexOf('0 ratings') !== -1 || ariaLabel.indexOf('null stars') !== -1)) {
          widget.style.display = 'none';
          if (parentBlock) {
            parentBlock.style.display = 'none';
          }
          hid = true;
          dbg('hide:apply', runSource, 'reason:aria-zero', summary);
        }
      }
      if (!hid && label && labelText === '0 reviews') {
        widget.style.display = 'none';
        if (parentBlock) {
          parentBlock.style.display = 'none';
        }
        hid = true;
        dbg('hide:apply', runSource, 'reason:label-zero', summary);
      }
      if (!hid) {
        dbg('hide:skip', runSource, summary);
      }
    });
  }

  function scheduleHide(runSource) {
    return function () {
      hideKlaviyoZeroReviews(runSource);
    };
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHide('domcontentloaded'));
  } else {
    hideKlaviyoZeroReviews('sync');
  }
  
  setTimeout(scheduleHide('timeout-1000'), 1000);
  setTimeout(scheduleHide('timeout-2500'), 2500);
  setTimeout(scheduleHide('timeout-5000'), 5000);
  setTimeout(scheduleHide('timeout-8000'), 8000);
  setTimeout(scheduleHide('timeout-12000'), 12000);
  setTimeout(scheduleHide('timeout-20000'), 20000);
  setTimeout(scheduleHide('timeout-30000'), 30000);

  window.addEventListener('load', scheduleHide('window-load'));
  
  var hideKlaviyoDebounce = null;
  function scheduleHideKlaviyoDebounced(source) {
    if (hideKlaviyoDebounce) {
      clearTimeout(hideKlaviyoDebounce);
    }
    hideKlaviyoDebounce = setTimeout(function () {
      hideKlaviyoDebounce = null;
      hideKlaviyoZeroReviews(source);
    }, 100);
  }

  var observer = new MutationObserver(function(mutations) {
    var shouldCheck = false;
    var mutationHint = [];
    for (var m = 0; m < mutations.length; m++) {
      var mutation = mutations[m];
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i];
          if (node.nodeType === 1) {
            var isKlaviyoShell =
              (node.classList && node.classList.contains('klaviyo-star-rating-widget')) ||
              (node.id && (node.id === 'klaviyo-product-reviews-wrapper' || node.id === 'fulfilled-reviews-all')) ||
              (node.querySelector &&
                (node.querySelector('.klaviyo-star-rating-widget') ||
                  node.querySelector('#klaviyo-product-reviews-wrapper') ||
                  node.querySelector('#fulfilled-reviews-all')));
            if (isKlaviyoShell) {
              shouldCheck = true;
              mutationHint.push('childList:klaviyo');
              break;
            }
          }
        }
      }
      if (!shouldCheck && mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
        if (mutation.target && mutation.target.closest && mutation.target.closest('.klaviyo-star-rating-widget')) {
          shouldCheck = true;
          mutationHint.push('attr:aria-label');
        }
      }
      if (!shouldCheck && mutation.type === 'characterData' && mutation.target && mutation.target.parentElement) {
        if (mutation.target.parentElement.closest && mutation.target.parentElement.closest('.klaviyo-star-rating-widget')) {
          shouldCheck = true;
          mutationHint.push('characterData');
        }
      }
      if (shouldCheck) {
        break;
      }
    }
    if (shouldCheck) {
      dbg('hide:mutation', mutationHint.length ? mutationHint.join(',') : 'unknown');
      scheduleHideKlaviyoDebounced('mutation-observer');
    }
  });
  
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label'],
    characterData: true
  });
})();

/**
 * Product Pricing Layout Enhancement
 * Moves payment widgets (Humm, Afterpay) into the new pricing container
 */
(function() {
  function setupPricingLayout() {
    const pricingContainer = document.querySelector('.ProductMeta__PricingContainer');
    const paymentColumn = document.querySelector('.ProductMeta__PaymentColumn');
    const afterpayInfoContainer = document.getElementById('productMetaAfterpayInfo');
    
    if (!pricingContainer || !paymentColumn || !afterpayInfoContainer) return;
    
    // Find the Afterpay app block and MOVE (not clone) it into our container
    // Look for the Shopify app block containing afterpay
    const afterpayAppBlock = document.querySelector('.shopify-app-block:has(afterpay-placement), .shopify-app-block:has(square-placement)');
    
    if (afterpayAppBlock && !afterpayInfoContainer.contains(afterpayAppBlock)) {
      // Check if we haven't already moved it
      if (!afterpayInfoContainer.hasChildNodes()) {
        // Move the actual element (not clone) to preserve functionality
        afterpayInfoContainer.appendChild(afterpayAppBlock);
      }
    }
    
    // Fallback: if :has() not supported, find by checking children
    if (!afterpayInfoContainer.hasChildNodes()) {
      const allShopifyBlocks = document.querySelectorAll('.shopify-app-block');
      allShopifyBlocks.forEach(function(block) {
        const hasAfterpay = block.querySelector('afterpay-placement, square-placement');
        if (hasAfterpay && !afterpayInfoContainer.contains(block)) {
          afterpayInfoContainer.appendChild(block);
        }
      });
    }
  }
  
  // Run after page load with delays to ensure widgets are loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(setupPricingLayout, 500);
      setTimeout(setupPricingLayout, 1500);
      setTimeout(setupPricingLayout, 3000);
    });
  } else {
    setTimeout(setupPricingLayout, 500);
    setTimeout(setupPricingLayout, 1500);
    setTimeout(setupPricingLayout, 3000);
  }
})();

/**
 * Move Klaviyo Reviews Under Product Title
 * Moves the Klaviyo average rating widget to appear directly under the product title
 */
(function() {
  var dbg = window.__klaviyoReviewsDebugLog || function () {};

  function moveKlaviyoReviews(runSource) {
    runSource = runSource || 'move';
    var reviewsPlaceholder = document.getElementById('productMetaReviews');
    if (!reviewsPlaceholder) {
      dbg('move:skip', runSource, 'no #productMetaReviews (wrong template or snippet?)');
      return;
    }

    var klaviyoReviewsBlock = document.querySelector('.shopify-app-block:has(.klaviyo-star-rating-widget)');
    var placeholderEmpty = !reviewsPlaceholder.hasChildNodes();
    dbg('move:check', runSource, {
      foundBlockHas: !!klaviyoReviewsBlock,
      placeholderChildCount: reviewsPlaceholder.childNodes.length,
      placeholderEmpty: placeholderEmpty,
      globalKlaviyoWidgets: document.querySelectorAll('.klaviyo-star-rating-widget').length
    });

    if (klaviyoReviewsBlock && !reviewsPlaceholder.contains(klaviyoReviewsBlock)) {
      if (!reviewsPlaceholder.hasChildNodes()) {
        reviewsPlaceholder.appendChild(klaviyoReviewsBlock);
        dbg('move:done', runSource, 'appendChild via :has()', { movedId: klaviyoReviewsBlock.id || null });
      } else {
        dbg('move:blocked', runSource, 'placeholder already has children (first move wins)', {
          firstChildId: reviewsPlaceholder.firstChild && reviewsPlaceholder.firstChild.id
        });
      }
    }

    if (!reviewsPlaceholder.hasChildNodes()) {
      var allShopifyBlocks = document.querySelectorAll('.shopify-app-block');
      var movedFallback = false;
      for (var b = 0; b < allShopifyBlocks.length; b++) {
        var block = allShopifyBlocks[b];
        var hasKlaviyo = block.querySelector('.klaviyo-star-rating-widget');
        if (hasKlaviyo && !reviewsPlaceholder.contains(block)) {
          reviewsPlaceholder.appendChild(block);
          movedFallback = true;
          dbg('move:done', runSource, 'appendChild fallback scan', { movedId: block.id || null });
          break;
        }
      }
      if (!movedFallback) {
        dbg('move:pending', runSource, 'no .klaviyo-star-rating-widget inside .shopify-app-block yet');
      }
    }
  }

  function scheduleMove(delay, label) {
    return function () {
      moveKlaviyoReviews('timeout-' + delay + 'ms' + (label ? '-' + label : ''));
    };
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(scheduleMove(500, 'a'), 500);
      setTimeout(scheduleMove(1500, 'b'), 1500);
      setTimeout(scheduleMove(3000, 'c'), 3000);
      setTimeout(scheduleMove(8000, 'd'), 8000);
      setTimeout(scheduleMove(12000, 'e'), 12000);
      setTimeout(scheduleMove(20000, 'f'), 20000);
    });
  } else {
    setTimeout(scheduleMove(500, 'a'), 500);
    setTimeout(scheduleMove(1500, 'b'), 1500);
    setTimeout(scheduleMove(3000, 'c'), 3000);
    setTimeout(scheduleMove(8000, 'd'), 8000);
    setTimeout(scheduleMove(12000, 'e'), 12000);
    setTimeout(scheduleMove(20000, 'f'), 20000);
  }

  window.addEventListener('load', function () {
    moveKlaviyoReviews('window-load');
  });

  var moveDebounce = null;
  var moveObserver = new MutationObserver(function () {
    var ph = document.getElementById('productMetaReviews');
    if (!ph) {
      return;
    }
    if (ph.hasChildNodes()) {
      return;
    }
    if (!document.querySelector('.klaviyo-star-rating-widget')) {
      return;
    }
    if (moveDebounce) {
      clearTimeout(moveDebounce);
    }
    moveDebounce = setTimeout(function () {
      moveDebounce = null;
      moveKlaviyoReviews('mutation-debounced');
    }, 150);
  });
  moveObserver.observe(document.documentElement, { childList: true, subtree: true });
})();